module.exports = __webpack_public_path__ + "img/quant_unboundtoken.847da11.png";